import { IActionButtonSettings } from "modules/common/models"

export const actionButtonSettingsAreValid = (buttonSettings: IActionButtonSettings): boolean => 
    buttonSettings.isActive && (!!buttonSettings.link || !!buttonSettings.text);